import axios from "axios";
import { useEffect, useState } from "react";
import getUrl from "./getUrl";
import transformData from "./transformData";

const useData = (metric, scenario, country) => {
  const [chartData, setChartData] = useState([]);

  const url = getUrl(metric, scenario, country);

  const fetchData = (url) => {
    axios.get(url).then((res) => {
      setChartData(transformData(res.data));
    });
  };

  useEffect(() => {
    fetchData(url);
  }, [url]);

  return chartData;
};

export default useData;
